import ScrollTrigger from 'gsap/ScrollTrigger'

import {
    magnificPopupIframe,
    magnificPopupInline,
    magnificPopupSingleImage,
    magnificPopupGalleryImage,
} from './popups'
import { basicSlider } from './sliders'
import { linksCustomization, scrollTo, responsiveTables } from './misc'
import setScrollBarWidth from 'set-scrollbar-width' // Use with the Tailwind Container Break Out extension.

/* Flexible Content */
import accordion from '../../templates/blocks/accordion/accordion'
import statSlider from '../../templates/blocks/stats/stats'
import {
    testimonialNoImageSlider,
    testimonialImageSlider,
} from '../../templates/blocks/testimonial-slider/testimonial-slider'
import imageSlider from '../../templates/blocks/image-slider/image-slider'
import textWithImageSlider from '../../templates/blocks/text-with-image-slider/text-with-image-slider'
import bannerParallax from '../../templates/sections/banner/banner'
import gridLifeAtCumnor from '../../templates/sections/explore-life-at-cumnor/explore-life-at-cumnor'
import results from '../../templates/sections/results/results'
import featuredNewsSlider from '../../templates/blocks/featured-news-slider/featured-news-slider'
import homepageIntro from '../../templates/sections/homepage-intro/homepage-intro'
import socialSlider from '../../templates/blocks/social-slider/social-slider'
import admissionsProcess from '../../templates/blocks/admissions-process/admissions-process'

// Import animations
import scrollAnimations from './scrollAnimations'
import { animateHeaderIn } from './header'
import staffList from '../../templates/sections/staff-list/staff-list'
import slideEvents from './slideEvents'
import instagramSlider from '../../templates/blocks/instagram-slider/instagram-slider'
import animateFooterIn from './footer'
import initAwardsPopups from '../../templates/blocks/awards/awards'
import whatsHappening from '../../templates/sections/whats-happening/whats-happening'
import { imgZoom } from './imgZoom'

function consoleMessage() {
    console.log(
        '%cCreated by %cTWK%cwww.thewebkitchen.co.uk',
        'background: #13212E; color: #FFFFFF; padding: 5px 0px 5px 10px; margin: 25px 0px;',
        'background: #13212E; color: #05E5C8; padding: 5px 10px 5px 0px; font-weight: bold;',
        'background: #FFFFFF; padding: 5px 10px;'
    )
}

window.onbeforeunload = function () {
    window.scrollTo(0, 0)
}

function usingJS() {
    document.querySelector('html').classList.remove('no-js')
    document.querySelector('html').classList.add('js')
}

/* *********************** */
/* Start all the functions */
/* *********************** */
usingJS()

if (window.innerWidth < 768) {
    document.getElementById('page-wrap').style.overflowX = 'hidden'
}

window.addEventListener('resize', function () {
    if (window.innerWidth < 768) {
        document.getElementById('page-wrap').style.overflowX = 'hidden'
    }
})

window.onload = function () {
    // Init
    consoleMessage()
    setScrollBarWidth()
    linksCustomization()
    // scrollTo()
    responsiveTables()
    animateHeaderIn()
    animateFooterIn()

    // Popups
    magnificPopupIframe()
    magnificPopupInline()
    magnificPopupSingleImage()
    magnificPopupGalleryImage()

    // Flexible Content
    imgZoom()
    accordion()
    statSlider()
    testimonialNoImageSlider()
    testimonialImageSlider()
    imageSlider()
    textWithImageSlider()
    bannerParallax()
    admissionsProcess()
    initAwardsPopups()

    // Sections
    homepageIntro()
    gridLifeAtCumnor()
    results()
    whatsHappening()
    staffList()

    // Sliders
    basicSlider()
    featuredNewsSlider()
    socialSlider()
    slideEvents()
    instagramSlider()
}

// Animations
scrollAnimations()

jQuery(document).ready(function ($) {
    ajax: {
        /**
         * Detects the "Search & Filter" plugin ajax call and re-starts "Magnific popup".
         */
        $(document).on('sf:ajaxfinish', '.searchandfilter', function () {
            magnificPopupIframe()
            magnificPopupInline()
            magnificPopupSingleImage()
            magnificPopupGalleryImage()
        })
    }

    // ISAMS Form Widget
    var fwq = {
        apiRootUrl: 'https://cumnor.isams.cloud:443/api/Rest/1.0/',

        apiKey: '241922BB\x2DC98D\x2D4C65\x2D97B5\x2D3BDA1D275F2B',

        formInstance: 'b5e07964\x2Da10a\x2D4e46\x2D88c6\x2D094f5ada81a3',

        loadCustomJavascript: false,

        loadCustomCss: false,
    }

    ScrollTrigger.refresh()
})
